import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/map'
const url = '/api/v1/';

@Injectable()
export class AllRoutesService {

  constructor(private http: Http) { }
  listRoutes(token: string) {
  	console.log(".....token",token);
  	return this.http.get(url+'admin/routes?token='+token)
  	.map((response: Response) =>response.json());
  }

  getVehicles(){
		return this.http.get(url+'transporter/vehicle/types').map((response: Response) =>response.json());
	}
}
